import React from 'react';

const MoreIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.25 19.5a1.124 1.124 0 1 1 .001 2.249 1.124 1.124 0 0 1-.001-2.249zm0-5.625a1.124 1.124 0 1 1 .001 2.249 1.124 1.124 0 0 1-.001-2.249zm0-3.375a1.124 1.124 0 1 1-.001-2.249 1.124 1.124 0 0 1 .001 2.249z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MoreIcon;
